import { useEffect } from "react";

import "./index.scss";
import { IconButton } from "../../shared";
import {
    Box,
    ButtonGroup,
    Divider,
    Typography,
    useColorScheme,
    Button,
    IconButton as JoyIconButton,
    Input,
    Card,
    CardContent,
} from "@mui/joy";
import { Bell, ChevronDown, Moon, Plus, PlusCircle, Search, Settings, Sun, User } from "lucide-react";

import { useAuth } from "../../hooks";
import { Gate } from "../../shared";
import { PERMISSIONS } from "../../constants/permissions";
import { UserQuickNavigation } from "../../components";
import { Link } from "react-router-dom";

export default function Header() {
    const { mode, setMode } = useColorScheme();
    const { user } = useAuth();

    useEffect(() => {
        setMode("light");
    }, []);

    return (
        <header>
            <Box className={"main-header"}>
                <Box flex={1}>
                    <Input
                        startDecorator={<Search size={18} />}
                        endDecorator={<CustomEndDecorator />}
                        variant="soft"
                        sx={{ border: "1px solid", borderColor: "divider" }}
                        placeholder="Search or type a command"
                    />
                </Box>
                <Box mx={2}>
                    <Gate anyOf={[PERMISSIONS.PROJECT_CREATE]}>
                        <ButtonGroup aria-label="new project button" variant="solid" color="primary">
                            <Button startDecorator={<Plus size={18} />} component={Link} to="/project/new">
                                New Project
                            </Button>
                            <JoyIconButton>
                                <ChevronDown size={18} />
                            </JoyIconButton>
                        </ButtonGroup>
                    </Gate>
                </Box>
                <Box className={"main-header-action-items flex align-items-center"}>
                    <Gate anyOf={[PERMISSIONS.ADMIN_SETTINGS]}>
                        <Link to="/admin/manufacture/">
                            <IconButton>
                                <Settings size={18} />
                            </IconButton>
                        </Link>
                    </Gate>

                    <IconButton onClick={() => setMode(mode === "light" ? "dark" : "light")}>
                        {mode === "light" ? <Sun size={18} /> : <Moon size={18} />}
                    </IconButton>
                    <IconButton>
                        <PlusCircle size={18} />
                    </IconButton>
                    <IconButton>
                        <Bell size={18} />
                    </IconButton>
                    <Divider orientation="vertical" />
                    <UserQuickNavigation />
                </Box>
            </Box>
            <Divider />
        </header>
    );
}

function CustomEndDecorator() {
    return (
        <Card sx={{ p: 0.2, borderRadius: "6px", px: 1 }}>
            <CardContent>
                <Typography level="body-xs" sx={{ fontWeight: 500, color: "text.primary" }}>
                    ⌘ + K
                </Typography>
            </CardContent>
        </Card>
    );
}
